import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { AdminRoute } from './routing'
import { useAuth, UserModel } from '../modules/auth'
import AuthRole from '../role/roleAuth'
import { getProjectSession, modulesAllowedInProject } from '../component/helper'

const PrivateRoutes = () => {
  const { currentUser } = useAuth()
  const user: UserModel = currentUser as UserModel

  // let StaticAuth = [
  //   'auth',
  //   'dashboard',
  //   'roles',
  //   'company-management',
  //   'communication',
  //   'offers',
  //   'dispatch',
  //   'courier',
  //   'fullfillment',
  //   'telecalling',
  //   'FAQs',
  //   'address',
  //   'reports',
  //   'activity',
  //   'redemption-catalogue',
  //   'KYC'
  // ]

  // if (user?.company_id == '14') {
  //   StaticAuth = ['auth', 'dashboard']
  // }
  const projectSession = getProjectSession() as { project_modules?: string[] } | null
  let StaticAuth = projectSession
    ? ['auth', 'dashboard', 'project_settings']
    : ['auth', 'dashboard']

  if (!projectSession && user?.accesses?.role === "super-admin") {
    StaticAuth = ['roles', 'auth', 'redemption-list', 'vendor', 'dashboard']
  }
  const userModules = Array.isArray(user?.accesses?.modules) ? user.accesses.modules : [];
  // const scopedModules = projectSession
  //   ? modulesAllowedInProject(userModules, projectSession.project_modules || [])
  //   : userModules
  const moudles = [...userModules, ...StaticAuth];
  let routeData = [];
  // if (user?.company_id) {
  //   routeData = CompanyRoute
  // } else {
  //   routeData = AdminRoute
  // }
  routeData = AdminRoute
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {routeData.map((data, idex) => {
          return <Route element={<AuthRole module={data.module} moudles={moudles} />}>
            <Route key={idex} path={data.path} element={data.comp} />
          </Route>
        })
        }
        {/* <Route path='/user/kyc/user/:user_id' element={<KycModule />} /> */}
        {/* <Route path='/user/kyc/user/:comid/:mobile' element={<KycModule />} /> */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}



export { PrivateRoutes }
